import { SignaturePad as SmoothPad } from "./SignaturePad";
import { SignaturePromptModal } from "./SignaturePromptModal";

/**
 * SignaturePad wrapper kept for backward compatibility with older callers that only
 * import the raw pad and manage their own value locally.
 */
export function SignaturePad({ onChange }) {
  return <SmoothPad value="" height={160} onChange={(img) => onChange?.(img || null)} />;
}

/**
 * SignModal is now a thin compatibility shim over SignaturePromptModal so every existing
 * caller (Progress Notes, Assessments, Treatment Plans, Consent Forms, Crisis Plans,
 * plus their co-sign and addendum flows) automatically gets the global Draw, Type,
 * Upload, and Saved Signature tabs together with the ESIGN Act consent, without any
 * refactor at the call sites.
 *
 * Legacy contract:
 *   onSign({ name, image, witness_name })
 * SignaturePromptModal contract:
 *   onConfirm({ image, name, method, witness_name })
 * We map one to the other.
 */
export function SignModal({ open, onClose, onSign, title = "Sign Document", defaultName = "", withWitness = false, busy = false }) {
  const handleConfirm = async ({ image, name, witness_name }) => {
    await onSign?.({ name, image, witness_name });
  };
  return (
    <SignaturePromptModal
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={title}
      busy={busy}
      withWitness={withWitness}
      signerName={defaultName || undefined}
    />
  );
}
